module.exports = __webpack_public_path__ + "static/media/sign-D.77390372.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/products/sign-D.svg
// module id = 83
// module chunks = 0